import { render, staticRenderFns } from "./SelectDateRange.vue?vue&type=template&id=2b4e1913&"
import script from "./SelectDateRange.vue?vue&type=script&lang=js&"
export * from "./SelectDateRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b4e1913')) {
      api.createRecord('2b4e1913', component.options)
    } else {
      api.reload('2b4e1913', component.options)
    }
    module.hot.accept("./SelectDateRange.vue?vue&type=template&id=2b4e1913&", function () {
      api.rerender('2b4e1913', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/SelectDateRange.vue"
export default component.exports